<template>
    <div class="p-care__period">
        <h2 class="u-r-margin-top-40">
            Period {{ index + 1}}
        </h2>

        <control label="Start of Loss of Earnings">
            <date-input ref="startOfPeriod" v-model="period.startOfPeriod" @input="calculateLoss()"></date-input>
            <control-error :show="!periodStartIsValid">
                Date is required, must be in the format DD/MM/YYYY and must be before the End of Loss of Earnings Date
            </control-error>
        </control>

        <control label="End of Loss of Earnings">
            <date-input ref="endOfPeriod" @input="calculateLoss()" v-model="period.endOfPeriod"></date-input>
            <control-error :show="!periodEndIsValid">
                Date is required, must be in the format DD/MM/YYYY, and must be after the Start of Loss of Earnings Date
            </control-error>
        </control>

        <control label="Employment Type">
            <select ref="employmentType" @change="calculateLoss()" v-model="period.employmentType">
                <option :value="null">Please select...</option>
                <option value="employed">Employed</option>
                <option value="self_employed">Self-employed</option>
                <option value="part_employed">Part-employed</option>
                <option value="absence">Absent</option>
            </select>
        </control>

        <control label="Employment Income">
            <div class="a-form-inputs--half-calcs">
                <div class="a-form-inputs__container a-form-inputs--pound">
                    <input autocomplete="off" v-model="period.employmentIncome"
                           ref="employmentIncome"
                           @input="calculateLoss()"
                           v-two-dp
                           type="number">
                </div>
                <div class="a-form-inputs__container">
                    <select ref="employmentNetGross"
                            @change="calculateLoss()"
                            v-model="period.employmentNetGross">
                        <option value="gross">Gross</option>
                        <option value="net">Net</option>
                    </select>
                </div>
            </div>
        </control>

        <control>
            <button class="a-button a-button--smaller"
                    @click="deleteThisPeriod()"
                    :class="index===0?'disabled':''"
                    :disabled="index===0">
                Delete Income Period
            </button>
        </control>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import moment from 'moment';
    import DateInput from 'components/form/control/DateInput.vue'
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import VueSlider from 'vue-slider-component';
    import currencyFormat from 'mixins/currencyFormat';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'income-period',
        props: {
            period: {
                type: Object,
                default: {}
            },
            index: {
                type: Number,
            },
        },
        computed: {
            ...mapGetters('mini/lossOfEarnings', ['periods']),
            periodStartIsValid() {
                return !moment(this.period.periodStart, 'DD/MM/YYYY')
                    .isAfter(moment(this.period.periodEnd, 'DD/MM/YYYY'))
            },
            periodEndIsValid() {
                return !moment(this.period.periodEnd, 'DD/MM/YYYY')
                    .isBefore(moment(this.period.periodStart, 'DD/MM/YYYY'));
            },
            isValid() {
                return [
                    this.period.startOfPeriod !== null &&
                    this.period.startOfPeriod !== "" &&
                    this.period.endOfPeriod !== null &&
                    this.period.endOfPeriod !== "" &&
                    this.period.employmentType !== null &&
                    this.period.employmentIncome !== null &&
                    this.period.employmentIncome !== "" &&
                    this.periodStartIsValid &&
                    this.periodEndIsValid
                ];
            },
        },
        methods: {
            ...mapActions('mini/lossOfEarnings', {
                deletePeriod: 'deletePeriod',
                updatePeriod: 'updatePeriod',
            }),
            calculateLoss() {
                if (!this.isValid) {
                    return;
                }

                this.updatePeriod({index: this.index, period: this.period});
                this.$emit('update', {index: this.index});
            },
            deleteThisPeriod() {
                this.deletePeriod(this.index);
            }
        },
        components: {
            DateInput,
            Control,
            ControlError,
            VueSlider
        },
        mixins: [
            currencyFormat
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
    }
</script>


// WEBPACK FOOTER //
// IncomePeriod.vue?73698074